import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { NavLink, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

// Um cartão por módulo que o usuário realmente tem (GET /me da Uzerpass.Seguranca) — antes
// os 4 cartões eram fixos e apareciam pra todo mundo, sem checar permissão nenhuma. Portaria
// é um caso à parte: pode aparecer em "modulos" mesmo sem o usuário ter acesso de verdade —
// quem manda é o flag seguranca.portaria.acessaPortaria (mesma regra que decideRoteamentoModulo
// já usava em sagas/Seguranca.js).
const CONFIGURACAO_POR_MODULO = {
  backoffice: { label: 'Backoffice', icone: 'zmdi-account-box-o' },
  portaria: { label: 'Portaria', icone: 'zmdi-account-box-o' },
  comunicacao: { label: 'Comunicação', icone: 'zmdi-comment-text', rota: '/app/push' },
  'validacao-perfil': { label: 'Validação de Perfil', icone: 'zmdi-shield-check', rota: '/app/validacaoPerfil' },
};

class AlternaModulos extends Component {

    render() {

        let configuracao = this.props.configuracao;
        let exibeFechar = this.props.exibeFechar;
        let seguranca = this.props.seguranca || {};
        let modulos = (seguranca.modulos || []).filter(m =>
            m.codigo === 'portaria' ? !!(seguranca.portaria && seguranca.portaria.acessaPortaria) : true
        );

        const acionarModulo = (moduloConfig, codigo) => {
            if (codigo === 'backoffice' || codigo === 'portaria') {
                this.props.irParaModulo(moduloConfig.label, configuracao);
                return;
            }
            if (moduloConfig.rota) {
                this.props.funcaoFechar();
                this.props.history.push(moduloConfig.rota);
            }
        };

        return (<Fragment>
            <div style={{ flexGrow: 1 }}>
                <Grid style={{ marginTop: 10, textAlign: 'right' }} container spacing={3}>
                    <Grid item xs={12}>
                        {
                            exibeFechar &&
                            <Button startIcon={<CloseIcon style={{ color: '#05B59D' }} />} color="primary" style={{ marginRight: 8, padding: '14px 36px', borderRadius: 100, borderWidth: 2 }} variant="outlined" onClick={() => { this.props.funcaoFechar(); }}>
                                <span style={{ fontStyle: 'normal', fontFamily: 'Montserrat, sans-serif', fontWeight: 'bold', fontSize: '14px', letterSpacing: '1.25px', textTransform: 'none' }}>Fechar</span>
                            </Button>
                        }

                    </Grid>
                </Grid>
            </div>

            <Grid style={{ minHeight: 330, marginTop: 10, display: 'flex', justifyContent: 'center', textAlign: 'center', alignItems: 'center', width: '100%' }} container spacing={3}>
                {
                    modulos.length === 0 && (
                        <Grid item>
                            <div style={{ color: '#888' }}>Nenhum módulo disponível para este usuário.</div>
                        </Grid>
                    )
                }

                {
                    modulos.map(modulo => {
                        const moduloConfig = CONFIGURACAO_POR_MODULO[modulo.codigo];
                        if (!moduloConfig) return null;

                        return (
                            <Grid item key={modulo.id || modulo.codigo}>
                                <div style={{ cursor: 'pointer' }} onClick={() => acionarModulo(moduloConfig, modulo.codigo)}>
                                    <NavLink className="prepend-icon" to="/app/inicio">
                                        <div style={{ height: '82%', width: 175, margin: 14 }} className="jr-card bg-gradient-primary text-white text-center ripple-effect">
                                            <div className="mt-xl-1">
                                                <i className={`zmdi ${moduloConfig.icone} zmdi-hc-2x`}></i>
                                            </div>
                                            <h5 className="text mb-xl-1">{modulo.nome || moduloConfig.label}</h5>
                                        </div>
                                    </NavLink>
                                </div>
                            </Grid>
                        );
                    })
                }
            </Grid>
        </Fragment>
        );
    }
}

export default withRouter(AlternaModulos);
